<template>
  <Drawer
    :open="open"
    @update:open="$emit('update:open', $event)"
    variant="modal"
    background="white"
    :title="$t('components.task_details.checklist.edit.title')"
    showFooter
    :confirmLabel="$t('components.buttons.save')"
    @confirm="$emit('update:description', description)"
  >
    <template #content>
      <div class="p-4">
        <TextInput v-model="description" />
      </div>
    </template>
  </Drawer>
</template>

<script setup>
import { ref, watch } from "vue";
import { Drawer } from "@/SharedComponents/Drawer";
import { TextInput } from "@/SharedComponents/Inputs";

defineEmits(["update:description", "update:open"]);

const props = defineProps({
  open: { type: Boolean, required: true },
  item: { type: Object, required: true },
});

const description = ref(props.item.description);

watch(
  () => props.open,
  () => {
    if (props.open) {
      description.value = props.item.description;
    }
  },
  { immediate: true }
);
</script>
